import {
  CloseButtonProps as MantineCloseButtonProps,
  CloseButton as MantineCloseButton,
} from '@mantine/core';

export type CloseButtonProps = MantineCloseButtonProps;

export const CloseButton = MantineCloseButton as typeof MantineCloseButton;

CloseButton.displayName = 'CloseButton';
